import { render, staticRenderFns } from "./SubAccount.vue?vue&type=template&id=125a157a&scoped=true&"
import script from "./SubAccount.vue?vue&type=script&lang=js&"
export * from "./SubAccount.vue?vue&type=script&lang=js&"
import style0 from "./SubAccount.vue?vue&type=style&index=0&lang=css&"
import style1 from "./SubAccount.vue?vue&type=style&index=1&id=125a157a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125a157a",
  null
  
)

export default component.exports